import moment from 'moment';
import history from '../../core/history';
import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR
} from '../../constants';
import getPaymentMethodsQuery from '../../components/Payout/PayoutForm/getPaymentMethods.graphql';
import { userListingBook as query } from '../../lib/graphql/reservation/book';
import { getSpecialPricingData } from '../Listing/getSpecialPricingData';

export function bookingProcess(listId, guests, startDate, endDate, preApprove, restrictEdit, threadId) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOKING_PROCESS_START,
      payload: {
        bookingLoading: true
      }
    });

    try {
      const { data } = await client.query({
        query,
        variables: {
          listId: Number(listId)
        },
      });

      let payPalPayment = true, stripePayment = true, qrPayment = true;
      const getPaymentMethods = await client.query({
        query: getPaymentMethodsQuery,
        fetchPolicy: 'network-only',
      });

      getPaymentMethods?.data?.getPaymentMethods && getPaymentMethods?.data?.getPaymentMethods?.results && getPaymentMethods?.data?.getPaymentMethods?.results?.length > 0 && getPaymentMethods?.data?.getPaymentMethods?.results.map((item, index) => {
        if (!item.isEnable && item.id == 1) payPalPayment = false;
        if (!item.isEnable && item.id == 2) stripePayment = false;
        if (!item.isEnable && item.id == 3) qrPayment = false;
      });

      if (data?.UserListing) {
        dispatch({
          type: BOOKING_PROCESS_SUCCESS,
          payload: {
            data: data?.UserListing,
            bookDetails: {
              guests,
              startDate,
              endDate,
              preApprove,
              threadId
            },
            bookingLoading: false,
            payPalPayment,
            stripePayment,
            qrPayment,
            restrictEdit
          }
        });
        await dispatch(getSpecialPricingData(listId, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')));
        history.push('/book/' + listId);
      }

    } catch (error) {
      dispatch({
        type: BOOKING_PROCESS_ERROR,
        payload: {
          error,
          bookingLoading: false
        }
      });
      return false;
    }

    return true;
  };
}

